export default function simpleModal(content) {
  if (content === null) {
    return false;
  }

  const closeBtn = document.createElement("button");
  closeBtn.classList.add(
    "absolute",
    "input-button",
    "input-button-primary",
    "bottom-8"
  );
  closeBtn.innerText = "Close";
  closeBtn.addEventListener("click", closeModal);

  const modalHtml = `
  <div class="relative w-9/12">
    ${content}
  </div>
  `;

  const el = document.createElement("section");
  el.classList.add(
    "simpleModal",
    "fixed",
    "inset-0",
    "bg-black-off",
    "bg-opacity-75",
    "flex",
    "items-center",
    "justify-center",
    "z-20"
  );
  el.innerHTML = modalHtml;
  el.appendChild(closeBtn);

  document.body.appendChild(el);

  document.onkeydown = function(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
      isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
      isEscape = evt.keyCode === 27;
    }

    if (isEscape) {
      closeModal();
    }
  };
}

function closeModal() {
  const modal = document.querySelector(".simpleModal");
  modal.parentNode.removeChild(modal);
}
